import { getGlobalClassNames, HighContrastSelector } from '../../../Styling';
var GlobalClassNames = {
    root: 'ms-PlainCard-root'
};
export function getStyles(props) {
    var theme = props.theme, className = props.className;
    var classNames = getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                pointerEvents: 'auto',
                boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
                border: 'none',
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        border: '1px solid WindowText'
                    },
                    _a)
            },
            className
        ]
    };
    var _a;
}
//# sourceMappingURL=PlainCard.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/HoverCard/PlainCard/PlainCard.styles.js
// module id = 963
// module chunks = 0